import { render, staticRenderFns } from "./SubCategoryTable.vue?vue&type=template&id=dfb0af60"
import script from "./SubCategoryTable.vue?vue&type=script&lang=js"
export * from "./SubCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports